import React from "react";

export default function Home(props) {
  return (
    <div className={`${props.class.container}`}>
      <h1>Home</h1>
    </div>
  );
}
